import { useCallback } from "react";
import { observer } from "mobx-react";
import { useRootStore } from "@/state/RootStore";
import { RecoverableErrorBanner } from "./RecoverableErrorBanner";

/**
 * Shown when the profile fetch failed during bootstrap.
 *
 * `profileError` was previously written and read by nothing — the same dead-state bug
 * this file exists to close elsewhere. The app no longer skips entitlement loading when
 * the profile fails, but the user is still left with a profile that silently never
 * arrived: no name, no saved exam date, and a state selection that may look unset.
 */
export const ProfileErrorBanner = observer(() => {
  const store = useRootStore();

  const handleRetry = useCallback(
    () => store.mainAppStore.retryProfileLoad(),
    [store],
  );
  const stillFailing = useCallback(
    () => store.mainAppStore.profileError,
    [store],
  );

  if (!store.mainAppStore.profileError) return null;

  return (
    <RecoverableErrorBanner
      messageKey="errors.profile_unavailable"
      onRetry={handleRetry}
      stillFailing={stillFailing}
    />
  );
});

export default ProfileErrorBanner;
